import React from 'react';
import PropTypes from 'prop-types';

function ReceivedSample(props) {
  const { sampleGroup } = props;
  return (
    <tr key={sampleGroup.imr_id}>
      <td>{sampleGroup.imr_id}{ sampleGroup.submitted_by.length ? ` (${sampleGroup.submitted_by})` : ''}</td>
      <td>{sampleGroup.target}</td>
      <td>{sampleGroup.n_samples}</td>
    </tr>
  );
}

ReceivedSample.propTypes = {
  sampleGroup: PropTypes.object.isRequired
};

export default ReceivedSample;
